import { useTheme, Typography, Chip, Button, Tooltip } from "@mui/material";
import { Box, Paper } from '@mui/material';
import { tokens } from "../../theme";
import AddCircleIcon from '@mui/icons-material/AddCircle';

import { useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons'
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import PaymentForm from "./resume-section-kit-payment-form";

import { djangoApi } from "../../utils/axios/axios.utils";

import { useEffect } from "react";

import { updateSellersKitsIsPaidData } from "../../store/products/products.action";
import { useDispatch } from "react-redux";

const TruncatedText = ({ text, maxLength }) => {
    const truncatedText = text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

    return (
        <Tooltip title={text} arrow>
            <Typography sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {truncatedText}
            </Typography>
        </Tooltip>
    );
};

const ResumeSectionKitPayment = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const dispatch = useDispatch();


    const { dataToEdit, dataToShow, getKitPayments, setTotalPaidToPitaya, resumePaymentData, seller } = props

    const [formOpened, setFormOpened] = useState(false);
    const [initialValuesForm, setInitialValuesForm] = useState(null);
    const [isLoadingData, setIsLoadingData] = useState(false);

    const [totalPaid, setTotalPaid] = useState(0);

    useEffect(() => {
        if (dataToShow?.length > 0) {
            const total = dataToShow?.reduce((acc, curr) => acc += curr.value, 0)
            setTotalPaid(total)
            setTotalPaidToPitaya(total)
        } else {
            setTotalPaid(0)
            setTotalPaidToPitaya(0)
        }
    }, [dataToShow]);

    const formatNumber = (data) => {
        if (!data) {
            return " - "
        }
        return data?.toLocaleString(
            "pt-br",
            {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }
        )
    }


    const registerPaymentKit = async (formData) => {
        setIsLoadingData(true)
        try {
            const response = await djangoApi
                .post("products/kit_payment/update_and_create_kit_payment/", formData, {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                })
            console.log('response here', response)
            const data = {
                data: response?.data?.data,
                status: response.status
            }
            const isPaid = response?.data?.kit_is_paid
            console.log('is_paid_yet?', isPaid)
            dispatch(updateSellersKitsIsPaidData(dataToEdit, seller, isPaid))

            await getKitPayments()
            return data
        } catch (err) {
            console.log("Erro ao alterar as aplicações", err);
            window.alert(err);
            setIsLoadingData(false)
        } finally {
            // pass
            setIsLoadingData(false)
        }
    };

    const deleteKitPayment = async (pk) => {
        setIsLoadingData(true)
        try {
            const response = await djangoApi
                .post(`products/kit_payment/${pk}/delete_kit_payment/`, {}, {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                })
            return response
        } catch (err) {
            console.log("Erro ao pegar os dados", err);
            window.alert(err);
            setIsLoadingData(false)
        } finally {
            // pass
            setIsLoadingData(false)
        }
    };



    const handleUpdate = (data) => {
        setInitialValuesForm(data)
        setFormOpened(true)
    }

    const handleDelete = async (data) => {
        const isConfirmed = window.confirm(`Deseja Deletar essa transação no valor de R$ ${formatNumber(data.value)} ?`);
        if (isConfirmed) {
            try {
                const deleted = await deleteKitPayment(data.pk);
                console.log('deleted', deleted);
                await getKitPayments(); // Ensures it waits for the updated data
            } catch (error) {
                console.error("Error deleting the transaction:", error);
            }
        }
    }

    const handleAdd = () => {
        setFormOpened(!formOpened)
    }

    const handleClose = () => {
        setFormOpened(false)
        setInitialValuesForm(null)
    }

    const paymentMethods = {
        "01": "Dinheiro",
        "03": "Cartão de Crédito",
        "17": "Pix Dinamico",
        "20": "Pix Estatico",
        "99": "Outros"
    };
    
    // Function to get display name
    const getPaymentMethodName = (code) => paymentMethods[code] || "Não Definido";

    // if(dataToShow.length === 0){
    //     return <Typography variant="h6">Sem Transações</Typography>
    // }

    return (
        <Box
            component={Paper}
            elevation={8}
            sx={{
                display: 'flex',
                width: '100%',
                minHeight: '250px',
                padding: '10px',
                flexDirection: 'column',
                backgroundColor: colors.pink[800],
                // justifyContent: 'center',
                // alignSelf: 'center',
                gap: '20px',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    "& .MuiChip-root": {
                        borderRadius: 1.5
                    }
                }}
            >
                <Chip
                    label={totalPaid > 0 ? `Pagamentos - R$ ${formatNumber(totalPaid)}` : 'Pagamentos'}
                    sx={{ width: totalPaid > 0 ? '200px' : '150px', color: 'whitesmoke', fontWeight: 'bold', fontSize: '14px' }}
                    color="success"
                >
                </Chip>
                <Button
                    startIcon={<AddCircleIcon size={24} color="inherit" />}
                    size="small"
                    color="success"
                    onClick={handleAdd}
                    sx={{ borderRadius: '6px', color: 'whitesmoke' }}
                    variant="contained"
                >
                    Adicionar
                </Button>
            </Box>
            {
                formOpened ?
                    <PaymentForm
                        handleCancel={handleClose}
                        initialValuesForm={initialValuesForm}
                        registerPaymentKit={registerPaymentKit}
                        isLoadingData={isLoadingData}
                        dataToEdit={dataToEdit}
                        resumePaymentData={resumePaymentData}
                        totalPaid={totalPaid}
                    />
                    :
                    <Box
                    // sx={{
                    // maxHeight: '100%',
                    // overflow: 'auto'
                    // }}
                    >
                        {
                            dataToShow.length === 0 ?
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '200px',
                                    }}
                                >
                                    <Typography variant="h6">Sem Transações Cadastradas</Typography>
                                </Box>

                                :
                                <>

                                    <Paper
                                        component={Box}
                                        elevation={8}
                                        sx={{
                                            display: 'grid',
                                            gridTemplateColumns: '0.2fr 1fr 1fr 1fr 2fr 0.2fr',
                                            backgroundColor: colors.pink[700],
                                            padding: '0px 10px',
                                            paddingTop: '5px',
                                            marginBottom: '10px',
                                            position: 'sticky',
                                            top: 0
                                            // borderRadius: '6px'
                                        }}
                                    >
                                        <Typography>.</Typography>
                                        <Typography>Data</Typography>
                                        <Typography>Valor</Typography>
                                        <Typography>Tipo</Typography>
                                        <Typography>Observações</Typography>
                                        <Typography>Ação</Typography>
                                    </Paper>


                                    {
                                        dataToShow.map((data, i) => {
                                            return (
                                                <Box
                                                    key={i}
                                                    sx={{
                                                        display: 'grid',
                                                        gridTemplateColumns: '0.2fr 1fr 1fr 1fr 2fr 0.2fr',
                                                        backgroundColor: i % 2 === 0 ? colors.pink[700] : colors.pink[600],
                                                        padding: '2px 10px',
                                                        margin: '3px 0px',
                                                        transition: 'background-color 0.3s ease', // Smooth transition
                                                        '&:hover': {
                                                            backgroundColor: colors.pink[400], // Change background on hover
                                                            cursor: 'pointer', // Add pointer cursor for interactivity
                                                        },
                                                        // borderRadius: '6px'
                                                    }}
                                                >
                                                    <Typography>{i + 1}</Typography>
                                                    <Typography>{data.date}</Typography>
                                                    <Typography>R$ {formatNumber(data.value)}</Typography>
                                                    <Typography>{getPaymentMethodName(data.payment_method)}</Typography>
                                                    <Typography><TruncatedText text={data.obs} maxLength={20} /></Typography>
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'flex-end',
                                                            gap: '20px'
                                                        }}
                                                    >
                                                        <Box
                                                            onClick={() => handleUpdate(data)}
                                                            sx={{
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                width: '20px',
                                                                height: '20px',
                                                                borderRadius: '50%',
                                                                cursor: 'pointer',
                                                                transition: 'background-color 0.3s ease',
                                                                backgroundColor: 'transparent',
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(255, 0, 0, 0.1)', // Light red hover background
                                                                },
                                                                '&:active': {
                                                                    backgroundColor: 'rgba(255, 0, 0, 0.2)', // Darker red on click
                                                                },
                                                            }}
                                                        >
                                                            <FontAwesomeIcon
                                                                size="lg"
                                                                icon={faPenToSquare}
                                                                color={colors.yellow[600]}
                                                            />
                                                        </Box>
                                                        <Box
                                                            onClick={() => handleDelete(data)}
                                                            sx={{
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                width: '20px',
                                                                height: '20px',
                                                                borderRadius: '50%',
                                                                cursor: 'pointer',
                                                                transition: 'background-color 0.3s ease',
                                                                backgroundColor: 'transparent',
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(255, 0, 0, 0.1)', // Light red hover background
                                                                },
                                                                '&:active': {
                                                                    backgroundColor: 'rgba(255, 0, 0, 0.2)', // Darker red on click
                                                                },
                                                            }}
                                                        >
                                                            <FontAwesomeIcon
                                                                size="lg"
                                                                icon={faTrash}
                                                                color={colors.redAccent[500]}
                                                            />
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            )
                                        })
                                    }
                                </>
                        }

                    </Box>

            }

        </Box>
    );
}

export default ResumeSectionKitPayment;